module.exports = __webpack_public_path__ + "img/logo-social.d0fd8938.png";